export default __webpack_public_path__ + "static/media/logo3.f2828c3a.svg";